import { render, staticRenderFns } from "./ReportDocumentAssignmentModal.vue?vue&type=template&id=40b3119e&scoped=true&"
import script from "./ReportDocumentAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./ReportDocumentAssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3119e",
  null
  
)

export default component.exports